<template>
  <div class="app-logo">
    <img src="@/assets/images/logo.png" />
  </div>
</template>



<style scoped>
  img {
    border-radius: 8px;
    object-fit: fill;
    width: 300px;
    height: 40px;
  }
</style>

<script setup lang="ts">

</script>